<template>
    <div v-if="loading == false">
        <ChirpReport
            :data_source="rows"
            :export_report="export_report"
            :column_meta="headers"
            :preFormattedData="true"
            @rowSelected="handleRowClicked"
            :loadingColumns="loadingTable"
            :storeKey="storeKey"
            :useOverride="useOverride"
            :totalCount="totalCount"
            @cancelOverride="useOverride = false"
        />
    </div>
</template>
<script>
    import { tryGetFilter } from '@/util/tryGetFilter';

    const api_root = 'reports';
    const report = 'client_aging';
    import ChirpReport from '@/components/general/list/ChirpReport';
    export default {
        name: 'Aging',
        components: { ChirpReport },
        props: {
            overrideFilter: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                rows: [],
                useOverride: false,
                totalCount: 0,
                headers: [
                    { field: 'client_name', headerText: 'Client Name', allowSorting: true },
                    { field: 'amount_owed_30', headerText: '30 Days', allowSorting: true, align: 'Right', headerAlign: 'Right' },
                    { field: 'amount_owed_60', headerText: '60 Days', allowSorting: true, align: 'Right', headerAlign: 'Right' },
                    { field: 'amount_owed_90', headerText: '90 Days', allowSorting: true, align: 'Right', headerAlign: 'Right' },
                ],
                targetPage: 'ClientBilling',
                loading: true,
                loadingTable: false,
                criteriaProps: {},
                export_report: 'client_aging'
            };
        },
        computed: {
            criteria() {
                return this.useOverride && this.overrideFilter ? this.overrideCriteria : this.savedCriteria;
            },
            savedCriteria() {
                return tryGetFilter(this.$store, this.storeKey);
            },
            overrideCriteria() {
                return this.$store.getters['filters/overrideCriteria'](this.storeKey);
            },
            storeKey() {
                return this.pageMeta?.page || 'aging';
            },
        },
        methods: {
            async load_data(criteria = this.criteria) {
                const body = {
                    criteria: {
                        ...criteria,
                        report,
                    },
                };
                const res = await this.$api.post(`/${api_root}`, body);
                this.rows = res.data.rows.map((row) => ({
                    id: row.client_id,
                    client_name: row.client_name,
                    amount_owed_30:
                        row.amount_owed_30 < 0 ? this.$getCurrency(0) : this.$getCurrency(row.amount_owed_30),
                    amount_owed_60:
                        row.amount_owed_60 < 0 ? this.$getCurrency(0) : this.$getCurrency(row.amount_owed_60),
                    amount_owed_90:
                        row.amount_owed_90 < 0 ? this.$getCurrency(0) : this.$getCurrency(row.amount_owed_90),
                }));
                this.totalCount = res.data.total_count;

                if (
                    !criteria?.default_date_range ||
                    criteria?.default_date_range !== res.data.default_date_range
                ) {
                    this.$store.commit('filters/updateFilter', {
                        stateKey: this.storeKey,
                        criteria: {
                            ...criteria,
                            default_date_range: res.data.default_date_range,
                        },
                    });
                }

                this.$nextTick(() => {
                    this.loading = false;
                });
            },
            async init() {
                if (this.overrideFilter) {
                    this.useOverride = true;
                    this.$store.commit('filters/applyOverride', {
                        stateKey: this.storeKey,
                        criteria: this.overrideFilter,
                    });
                }

                await this.load_data();
            },
            async modifyCriteria(criteria) {
                if (this.targetPage) {
                    this.$store.commit('filters/update', {
                        criteriaPage: this.targetPage,
                        payload: criteria,
                    });
                }
                this.criteriaProps = criteria;
                await this.load_data();
            },
            async handleRowClicked(data) {
                await this.$router.push({ name: 'ClientBilling', params: { client_id: data.id } });
            },
        },
        async created() {
            await this.init();
        },
        watch: {
            criteria: {
                deep: true,
                async handler(newVal, oldVal) {
                    let updatedNewVal = { ...newVal };

                    if (Object.keys(newVal.sort).length === 0){
                        updatedNewVal.sort = oldVal.sort;
                    }

                    const newStr = JSON.stringify(updatedNewVal);
                    const oldStr = JSON.stringify(oldVal);
                    if (newStr !== oldStr) {
                        await this.load_data(updatedNewVal);
                    }
                },
            },
        },
    };
</script>
